/* ============================================================
   Notre Chanson — panier.js
   Renders the cart from saved state, keeps live totals as the
   user toggles order bumps / quantity, and opens a front-end
   confirmation (no real checkout — stops at the cart as required).
   ============================================================ */
(function () {
  'use strict';

  var A = NM.answers;
  var S = NM.state;
  var P = NM.PRICING;

  // Guard: nothing in the brief → back to composer.
  if (!A.relation) { window.location.replace(NM.route('composer')); return; }

  var name = NM.displayName();
  document.querySelectorAll('[data-name]').forEach(function (el) { el.textContent = name; });

  // Product line copy
  document.querySelector('[data-line-title]').textContent = 'Chanson pour ' + name;
  document.querySelector('[data-line-meta]').textContent = NM.genreLabel() + ' · Livré avant le ' + NM.deliveryLabel();

  function money(n) { return NM.money(n); }

  /* ---- Render summary + totals ---- */
  function render() {
    var qty = S.product.qty || 1;
    var lines = [];

    // Base song line (list → discounted)
    lines.push(
      '<div class="nm-summary__line"><span class="nm-summary__line-name">Chanson pour ' + escapeHtml(name) +
      (qty > 1 ? ' <small>× ' + qty + '</small>' : '') +
      '</span><span class="nm-summary__line-price"><span class="old">' + money(P.listPrice * qty) + '</span>' +
      money(P.basePrice * qty) + '</span></div>'
    );

    // Bumps
    Object.keys(S.bumps).forEach(function (id) {
      if (S.bumps[id] && P.bumps[id]) {
        var b = P.bumps[id];
        lines.push(
          '<div class="nm-summary__line nm-summary__line--bump"><span class="nm-summary__line-name">' + escapeHtml(b.label) +
          '</span><span class="nm-summary__line-price">' +
          (b.old ? '<span class="old">' + money(b.old) + '</span>' : '') +
          money(b.price) + '</span></div>'
        );
      }
    });

    // Pourboire
    if (S.tip && P.tips[S.tip]) {
      lines.push(
        '<div class="nm-summary__line nm-summary__line--bump"><span class="nm-summary__line-name">Pourboire (' +
        P.tips[S.tip].pct + ' %)</span><span class="nm-summary__line-price">' + money(P.tips[S.tip].price) + '</span></div>'
      );
    }

    document.querySelector('[data-summary-lines]').innerHTML = lines.join('');

    var t = NM.cartTotals();
    document.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = money(t.total); });
    document.querySelectorAll('[data-list]').forEach(function (el) { el.textContent = money(t.listTotal); });
    var saveEl = document.querySelector('[data-total-save]');
    if (saveEl) saveEl.textContent = 'Économisez ' + money(t.savings);
    document.querySelector('[data-qty-val]').textContent = qty;

    /* Prix des options (coffret, couplet, express, pourboires) : on les
       réécrit depuis PRICING, qui contient déjà les montants convertis
       dans la devise du visiteur. Même source que le total du CTA, donc
       toujours cohérent — y compris si le rendu serveur diffère. */
    function setP(key, txt) {
      var el = document.querySelector('[data-p="' + key + '"]');
      if (el) el.textContent = txt;
    }
    function bumpPrices(id) {
      var b = P.bumps[id];
      if (!b) return;
      setP(id + '-new', money(b.price));
      if (b.old != null) {
        setP(id + '-old', money(b.old));
        setP(id + '-save', 'Économisez ' + money(b.old - b.price));
      }
    }
    bumpPrices('coffret');
    bumpPrices('couplet');
    bumpPrices('express');
    if (P.tips) {
      if (P.tips.tip5)  setP('tip5',  money(P.tips.tip5.price));
      if (P.tips.tip10) setP('tip10', money(P.tips.tip10.price));
      if (P.tips.tip15) setP('tip15', money(P.tips.tip15.price));
    }
  }

  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---- Options conditionnées à l'existence d'une variante Shopify ----
     Sans variante, l'article ne partirait pas au paiement alors que son
     prix s'afficherait dans le total : on masque plutôt que de mentir. */
  document.querySelectorAll('[data-needs-variant]').forEach(function (el) {
    var id = el.getAttribute('data-needs-variant');
    var ok = window.NMShopify && NMShopify.hasVariant && NMShopify.hasVariant(id);
    el.hidden = !ok;
  });

  /* ---- Pourboire ---- */
  var tipOpts = document.querySelectorAll('[data-tip]');
  var tipThanks = document.querySelector('[data-tip-thanks]');
  function paintTip() {
    tipOpts.forEach(function (b) {
      var on = (b.getAttribute('data-tip') || null) === (S.tip || null);
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', String(on));
    });
    if (tipThanks) tipThanks.hidden = !S.tip;
  }
  tipOpts.forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.getAttribute('data-tip') || null;
      // Ne propose que des pourboires réellement facturables.
      if (id && !(window.NMShopify && NMShopify.hasVariant(id))) return;
      NM.setTip(id);
      paintTip();
      render();
    });
  });
  paintTip();

  /* ---- Bumps ---- */
  document.querySelectorAll('[data-bump-cb]').forEach(function (cb) {
    var id = cb.getAttribute('data-bump-cb');
    cb.checked = !!S.bumps[id];
    cb.addEventListener('change', function () { NM.setBump(id, cb.checked); render(); });
  });

  /* ---- Quantity ---- */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.getAttribute('data-qty'), 10);
      var next = Math.min(9, Math.max(1, (S.product.qty || 1) + delta));
      S.product.qty = next; NM.save(); render();
    });
  });

  /* ---- Checkout (front-end confirmation only) ---- */
  var modal = document.getElementById('checkout-modal');
  function openModal() {
    var t = NM.cartTotals();
    var rows = ['<div class="r"><span>Chanson pour ' + escapeHtml(name) + (t.qty > 1 ? ' × ' + t.qty : '') + '</span><b>' + money(P.basePrice * t.qty) + '</b></div>'];
    Object.keys(S.bumps).forEach(function (id) {
      if (S.bumps[id] && P.bumps[id]) rows.push('<div class="r"><span>' + escapeHtml(P.bumps[id].label) + '</span><b>' + money(P.bumps[id].price) + '</b></div>');
    });
    rows.push('<div class="r r--total"><span>Total</span><b>' + money(t.total) + '</b></div>');
    if (S.email) rows.push('<div class="r"><span>Envoi à</span><b>' + escapeHtml(S.email) + '</b></div>');
    modal.querySelector('[data-modal-recap]').innerHTML = rows.join('');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }

  /* Real Shopify checkout when configured, else the demo confirmation modal.
     While the cart is being created we lock the buttons and show a label so
     the user gets feedback and can't double-submit. */
  var checkingOut = false;
  function handleCheckout(btn) {
    /* Pas de nmPixel('InitiateCheckout') ici : Shopify le déclenche déjà au
       chargement de son checkout. Le tracker des deux côtés le compterait
       en double — on laisse Shopify seul propriétaire de cet événement. */
    var live = window.NMShopify && NMShopify.isConfigured();
    if (!live) { openModal(); return; }
    if (checkingOut) return;
    checkingOut = true;

    var buttons = document.querySelectorAll('[data-checkout]');
    var restore = [];
    buttons.forEach(function (b) {
      restore.push([b, b.innerHTML, b.disabled]);
      b.disabled = true;
      b.style.opacity = '0.75';
    });
    var main = btn && btn.querySelector('.nm-stickybar__main');
    if (main) main.textContent = 'Redirection…';
    else if (btn) btn.innerHTML = 'Redirection vers le paiement…';

    NMShopify.checkout().then(function (res) {
      if (res && res.url) { window.location.href = res.url; return; }
      // Failure → restore buttons + surface the reason, keep the cart intact.
      checkingOut = false;
      restore.forEach(function (r) { r[0].innerHTML = r[1]; r[0].disabled = r[2]; r[0].style.opacity = ''; });
      alert('Le paiement n\'a pas pu démarrer : ' + ((res && res.error) || 'erreur inconnue') + '\n\nVotre panier est conservé, réessayez.');
    });
  }

  document.querySelectorAll('[data-checkout]').forEach(function (b) {
    b.addEventListener('click', function () { handleCheckout(b); });
  });
  modal.addEventListener('click', function (e) { if (e.target.closest('[data-modal-close]')) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

  render();

  /* Meta Pixel — panier atteint (produit configuré prêt à l'achat). */
  if (window.nmPixel) {
    var initT = NM.cartTotals();
    nmPixel('AddToCart', { content_name: 'Chanson personnalisée', content_type: 'product', value: initT.total, currency: 'EUR', num_items: initT.qty });
  }
})();
